import { defineMessages } from 'react-intl';

const messages = defineMessages({
  AddItem: {
    id: 'label_add_item',
    defaultMessage: 'Add item',
  },
  Module: {
    id: 'label_module',
    defaultMessage: 'Module',
  },
  Category: {
    id: 'label_category',
    defaultMessage: 'Category',
  },
  MandatoryProgram: {
    id: 'modules_mandatory_program',
    defaultMessage: 'Mandatory Program',
  },
  ElectiveProgram: {
    id: 'modules_elective_program',
    defaultMessage: 'Elective Program',
  },
  ElectiveMandatoryProgram: {
    id: 'modules_elective_mandatory_program',
    defaultMessage: 'Elective Mandatory Program',
  },
});

export const ModuleSchema = (props) => ({
  addMessage: props.intl.formatMessage(messages.AddItem),
  fieldsets: [
    {
      fields: ['module', 'category'],
      id: 'default',
      title: '',
    },
  ],
  properties: {
    module: {
      title: props.intl.formatMessage(messages.Module),
      widgetOptions: {
        frontendOptions: {
          widget: 'object_browser',
          widgetProps: {
            mode: 'single',
            return: 'single',
            selectableTypes: ['ContinuingEducation'],
          },
        },
      },
    },
    category: {
      title: props.intl.formatMessage(messages.Category),
      widgetOptions: {
        frontendOptions: {
          widget: 'select',
          widgetProps: {
            choices: [
              [
                'MandatoryProgram',
                props.intl.formatMessage(messages.MandatoryProgram),
              ],
              [
                'ElectiveProgram',
                props.intl.formatMessage(messages.ElectiveProgram),
              ],
              [
                'ElectiveMandatoryProgram',
                props.intl.formatMessage(messages.ElectiveMandatoryProgram),
              ],
            ],
          },
        },
      },
    },
  },
  required: [],
  title: props.intl.formatMessage(messages.Module),
});
